export default __webpack_public_path__ + "static/media/Logo-No-Background.a591a154.png";